import * as acorn from 'acorn'

export function replaceWithSecrets(str, secrets) {
  if (!str) {
    return ''
  }
  return str.includes('{{{')
    ? this.call(
        'replaceLiteralsWithObjectFields',
        str,
        { bracketsLength: 3 },
        secrets
      )
    : str
}

export function replaceSecretsWithKeys(code, secrets) {
  if (!code || !secrets) {
    return code || ''
  }
  const secretKeys = Object.keys(secrets)
  if (secretKeys.length) {
    secretKeys.forEach((secret) => {
      const val = secrets[secret]
      // eslint-disable-next-line no-param-reassign
      code = code.replaceAll(val, `{{{ ${secret} }}}`)
    })
  }
  return code
}

export function getCode() {
  const { state } = this
  const route = this.call('getLocationPath', 0)
  const propsCode = this.parent.code
  if (propsCode === 'components') {
    return this.call('deepClone', state.value)
  } else if (propsCode === 'designSystem') {
    const rootCode = this.getDesignSystem() || {}
    const subRoute = route !== '/design-system' && route.slice(1).toUpperCase()
    return subRoute ? rootCode[subRoute] : rootCode
  } else if (propsCode === 'state') {
    const rootCode = this.getData('state') || {}
    const subRoute =
      this.call('getLocationPath', 1) &&
      this.call('getLocationPath', 1).slice(1)
    return subRoute ? rootCode[subRoute] : rootCode
  } else if (propsCode === 'data') {
    return this.getData()
  } else if (propsCode === 'schema') {
    return this.getSchema()
  }
}

export function stringifyCode(
  code,
  options = { preventExportDefult: false, syntax: '{}', indent: 0 }
) {
  const { state } = this
  const codeToConvert = code || this.call('getCode', this, state)
  const codeStr = this.call('isString', codeToConvert)
    ? codeToConvert
    : this.call('isFunction', codeToConvert)
      ? codeToConvert.toString()
      : this.call('objectToString', codeToConvert, options.indent)
  const exportDefault = options.preventExportDefult ? '' : 'export default '
  if (!codeToConvert) {
    return exportDefault + (options.syntax || '{}')
  }
  return exportDefault + this.replaceSecretsWithKeys(codeStr, this.getSecrets())
}

// export function evalStringCode(codeStr, opts = {}) {
//   if (!codeStr) {
//     return null
//   }
//   const codeVal = codeStr.startsWith('export default ')
//     ? codeStr.slice('export default '.length)
//     : codeStr
//   const code = this.replaceWithSecrets(codeVal, this.getSecrets?.())
//   return this.call('evalStringToObject', code, { verbose: true, ...opts })
// }

export function evalStringCodeUnsafe(codeStr, opts = {}) {
  if (!codeStr) {
    return null
  }
  const { secrets } = opts
  const codeVal = codeStr.startsWith('export default ')
    ? codeStr.slice('export default '.length)
    : codeStr
  const code = secrets ? this.replaceWithSecrets(codeVal, secrets) : codeVal
  const decoded = this.call('decodeNewlines', code)

  const onError = (e) => {
    this.error('Error while evaluating code:')
    this.log(codeStr)

    this.call('openNotification', {
      type: 'error',
      title: 'Error while evaluating code',
      message: 'Check the console to verbose'
    })

    throw new Error(e)
  }

  const objectified = this.call('evalStringToObject', decoded, {
    ...opts,
    onError: opts.onError || onError
  })

  if (objectified) return objectified
}

export function parseStringCode(codeStr, opts = {}) {
  if (!codeStr) return null

  if (codeStr.startsWith('export default '))
    codeStr = codeStr.slice('export default '.length)

  try {
    // Parse with range info so we can slice original code
    const ast = acorn.parse(`(${codeStr})`, {
      ecmaVersion: 'latest',
      sourceType: 'module',
      ranges: true
    })
    const objectExpression = ast.body[0].expression

    function slice(node) {
      return codeStr.slice(node.start - 1, node.end - 1) // adjust for wrapping ()
    }

    // ---- AST → Object or Raw Source ----
    function astToObject(node) {
      if (!node) return null

      switch (node.type) {
        case 'Literal':
          return node.value

        case 'TemplateLiteral':
          // preserve raw code including backticks
          return codeStr.slice(node.start, node.end - 2)

        case 'ArrayExpression':
          return node.elements.map((el) => (el ? astToObject(el) : null))

        case 'ObjectExpression':
          const obj = {}
          for (const prop of node.properties) {
            if (prop.type === 'Property') {
              const key =
                prop.key.type === 'Identifier'
                  ? prop.key.name
                  : prop.key.type === 'Literal'
                    ? prop.key.value
                    : codeStr.slice(prop.key.start - 1, prop.key.end - 1)

              obj[key] = astToObject(prop.value)
            } else if (prop.type === 'SpreadElement') {
              obj[
                `...${codeStr.slice(prop.argument.start - 1, prop.argument.end - 1)}`
              ] = astToObject(prop.argument)
            }
          }
          return obj

        default:
          return codeStr.slice(node.start - 1, node.end - 1)
      }
    }

    const objectified = astToObject(objectExpression)
    if (objectified) return objectified

    throw new Error('Failed to parse object')
  } catch (e) {
    if (opts.onError) opts.onError(e)
    console.error('Can not parse the string: ' + e.message)
    console.error(e)
    return null
  }
}
